<template>
  <RevDrawer
    :name="modalName"
    size="large"
    :title="i18n(translations.title, { orderId: order.id })"
    @close="handleClose"
  >
    <template #body>
      <div class="space-y-32">
        <RevTabs :label="i18n(translations.tabsBar)" scrollable>
          <RevTabItem
            key="order-details"
            :active="isOrderDetailVisible"
            :label="i18n(translations.orderDetailsTab)"
            @click="openOrderDetails(order.id)"
          />
          <RevTabItem
            key="financial-details"
            :active="isFinancialDetailsVisible"
            :label="i18n(translations.financialDetailsTab)"
            @click="openFinancialDetails(order.id)"
          />
        </RevTabs>

        <OrderDetailsTab v-if="isOrderDetailVisible" :order />
        <FinancialDetailsTab v-if="isFinancialDetailsVisible" :order />
      </div>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'
import { RevTabItem } from '@ds/components/TabItem'
import { RevTabs } from '@ds/components/Tabs'

import type { Order } from '../../../../../../../../Tab.types'
import { useOrderRecapDrawer } from '../../../../../../composables/useOrderRecapDrawer'

import { MODAL_NAME } from './OrderRecapDrawer.constants'
import translations from './OrderRecapDrawer.translations'
import FinancialDetailsTab from './components/FinancialDetailsTab/FinancialDetailsTab.vue'
import OrderDetailsTab from './components/OrderDetailsTab/OrderDetailsTab.vue'

const {
  isFinancialDetailsVisible,
  isOrderDetailVisible,
  closeRecapDrawer,
  openFinancialDetails,
  openOrderDetails,
} = useOrderRecapDrawer()

const props = defineProps<{ order: Order }>()

const i18n = useI18n()

const modalName = computed(() => MODAL_NAME + props.order.id)

async function handleClose() {
  await closeRecapDrawer()
}
</script>
